import React, {useState, useEffect} from 'react';
import {Form, Button, Nav, Row, Col, Card} from "react-bootstrap";
import axios from "axios";
import {Link, useNavigate, useParams} from "react-router-dom";
import {useSelector} from "react-redux";
import CreateClient from "./CreateClient";
import ReactPaginate from "react-paginate";

const FinishedWorkOrders = () => {

    let navigate = useNavigate();
    const [useId, setId] = useState()

    const [offset, setOffset] = useState(0);
    const [data, setData] = useState([]);
    const [perPage] = useState(10);
    const [pageCount, setPageCount] = useState(0)


    const {id} = useParams();
    const userLogin = useSelector(state => state.userLogin);
    const {userInfo} = userLogin;

    let redirect = ''
    if (userInfo) {
        if (userInfo.group === "AdminSuper") {
            redirect = '/inspections_dash'
        } else if (userInfo.group === "Finance") {
            redirect = '/finance_active_work_orders'
        } else if (userInfo.group === "Logistics") {
            redirect = '/logistics_dash'
        } else if (userInfo.group === "Tech") {
            redirect = '/tech_work_orders'
        }
    }


    const [resp, setClientData] = useState({ clients: null, preSites: null, onSite:null, proposal:null, invoices:null, workOrders:null, checklists:null, workHours:null, priority:null, comments:null});


    const fetchData = async () => {
        const presite = await axios(
            `https://homesafetysolutions.pythonanywhere.com/api/presites/`,{
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }
            }
            // `http://127.0.0.1:8000/api/presites/`
        );
        const onsite = await axios(
            `https://homesafetysolutions.pythonanywhere.com/api/onsites/`,{
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }
            }
            // `http://127.0.0.1:8000/api/onsites/`
        );
        const proposal = await axios(
            `https://homesafetysolutions.pythonanywhere.com/api/proposals/`,{
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }
            }
            // `http://127.0.0.1:8000/api/proposals/`
        );
        const invoice = await axios(
            `https://homesafetysolutions.pythonanywhere.com/api/invoices/`,{
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }
            }
            // `http://127.0.0.1:8000/api/invoices/`
        );
        const workorder = await axios(
            `https://homesafetysolutions.pythonanywhere.com/api/workorders/`,{
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }
            }
            // `http://127.0.0.1:8000/api/workorders/`
        );
        const checklist = await axios(
            `https://homesafetysolutions.pythonanywhere.com/api/checklists/`,{
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }
            }
            // `http://127.0.0.1:8000/api/checklists/`
        );
        const hours = await axios(
            `https://homesafetysolutions.pythonanywhere.com/api/workhours/`,{
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }
            }
            // `http://127.0.0.1:8000/api/workhours/`
        );
        const prioirty = await axios(
            `https://homesafetysolutions.pythonanywhere.com/api/priority_reports/`,{
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }
            }
            // `http://127.0.0.1:8000/api/priority_reports/`
        );
        const comment = await axios(
            `https://homesafetysolutions.pythonanywhere.com/api/comments/`,{
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }
            }
            // `http://127.0.0.1:8000/api/comments/`
        );

        const clients = await axios(
            `https://homesafetysolutions.pythonanywhere.com/api/finished_work_orders/`,{
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }
            }
            // `http://127.0.0.1:8000/api/finished_work_orders/`
        );


        setClientData({
            data: clients.data,
            pres: presite.data,
            ons: onsite.data,
            prop: proposal.data,
            inv: invoice.data,
            workO: workorder.data,
            cl: checklist.data,
            hrs: hours.data,
            pri: prioirty.data,
            com: comment.data,
        });

        let activePreSites = presite.data.map((client) => client.client)
        let activeOnSites = onsite.data.map((client) => client.client)
        let activeProposals = proposal.data.map((client) => client.client)
        let activeInvoices = invoice.data.map((client) => client.client)
        let activeWorkOrders = workorder.data.map((client) => client.client)
        let activeCheckLists = checklist.data.map((client) => client.client)
        let activeWorkHours = hours.data.map((client) => client.client)
        let activePriorities = prioirty.data.map((client) => client.client)
        let activeTechComments = comment.data.map((client) => client.client)


        const data = clients.data;
        const slice = data.slice(offset, offset + perPage)
        const postData = slice.map(awo =>
            <div key={awo.id}>
                <Row
                    className={"workOrderRow"}
                    key={awo.work_site_address}
                >
                    <Col>
                        <Link className={'btn btn-primary'}
                              to={`/client_details/${awo.id}/`}>
                            {awo.work_site_address}
                        </Link>
                    </Col>

                    <Col>
                        {

                            activePreSites.includes(awo.id)
                                ?
                                (<Link className={'btn btn-info'}
                                       to={`/presite/${awo.id}/`}>
                                    Detail Pre-Site
                                </Link>)
                                :
                                (<Link className={'btn btn-warning'}
                                       to={`/clients/${awo.id}/addpresite`}>
                                    Add Pre-Site
                                </Link>)
                        }
                    </Col>

                    <Col>
                        {
                            activePreSites.includes(awo.id)
                                ?
                                ('So True')
                                &&
                                activeOnSites.includes(awo.id)
                                    ?
                                    (<Link className={'btn btn-info'}
                                           to={`/onsite/${awo.id}/`}>Detail
                                        OnSite</Link>)
                                    :
                                    (<Link className={'btn btn-warning'}
                                           to={`/clients/${awo.id}/addonsite/`}>Add
                                        OnSite</Link>)
                                :
                                ("Fill out Pre-Site")
                        }

                    </Col>

                    <Col>

                        {
                            activeOnSites.includes(awo.id)
                                ?
                                ('So True')
                                &&
                                activeProposals.includes(awo.id)
                                    ?
                                    (<Link className={'btn btn-info'}
                                           to={`/proposals/${awo.id}/`}>
                                        Detail Proposal
                                    </Link>)
                                    :
                                    (<Link className={'btn btn-warning'}
                                           to={`/clients/${awo.id}/addproposal/`}> Add
                                        Proposal </Link>)
                                :
                                ("Fill out On-Site")
                        }
                    </Col>

                    <Col>
                        {
                            activeProposals.includes(awo.id)
                                ?
                                ('So True')
                                &&
                                activeInvoices.includes(awo.id)
                                    ?
                                    (<Link className={'btn btn-info'}
                                           to={`/invoices/${awo.id}/`}> Detail
                                        Invoice </Link>)
                                    :
                                    (<Link className={'btn btn-warning'}
                                           to={`/clients/${awo.id}/addinvoice/`}>Add
                                        Invoice </Link>)
                                :
                                ("Fill out Proposal")
                        }
                    </Col>

                    <Col>
                        {
                            activeInvoices.includes(awo.id)
                                ?
                                ('So True')
                                &&
                                activeWorkOrders.includes(awo.id)
                                    ?
                                    (<Link className={'btn btn-info'}
                                           to={`/workorders/${awo.id}/`}> Detail
                                        Work-Order </Link>)
                                    :
                                    (<Link className={'btn btn-warning'}
                                           to={`/clients/${awo.id}/addworkorder/`}>Add
                                        Work-Order</Link>)
                                :
                                ("Fill out Invoice")
                        }

                    </Col>

                    <Col>
                        {
                            activeWorkOrders.includes(awo.id)
                                ?
                                ('So True')
                                &&
                                activeCheckLists.includes(awo.id)
                                    ?
                                    (<Link className={'btn btn-info'}
                                           to={`/checklist/${awo.id}/`}>
                                        Detail Check List
                                    </Link>)
                                    :
                                    (<Link className={'btn btn-warning'}
                                           to={`/clients/${awo.id}/addchecklist/`}>Add
                                        Check List </Link>)
                                :
                                ("Fill out Work Order")
                        }
                    </Col>

                    <Row className={'Row AddHourRow'}>

                        <Col className={"Col AddHourCol"}>
                            {
                                activeWorkOrders.includes(awo.id)
                                    ?
                                    ('So True')
                                    &&
                                    activeWorkOrders.includes(awo.id)
                                        ?
                                        <Link className={'btn btn-warning'}
                                              to={`/clients/${awo.id}/addhours/`}>Add Hours</Link>
                                        :
                                        ("Create Work Order For Job")
                                    :
                                    ("Create Work Order For Job")
                            }

                        </Col>
                        <Col className={"Col AddHourCol"}>
                            {
                                activeWorkOrders.includes(awo.id)
                                    ?
                                    ('So True')
                                    &&
                                    activeWorkOrders.includes(awo.id)
                                        ?
                                        (<Link className={'btn btn-info'} to={`/clienthours/${awo.id}/`}>
                                            Hours Worked
                                        </Link>)

                                        :
                                        ("Create Hours For Job")
                                    :
                                    ("Create Hours For Job")
                            }
                        </Col>

                        <Col className={"Col AddHourCol"}>
                            {
                                activeWorkOrders.includes(awo.id)
                                    ?
                                    ('So True')
                                    &&
                                    activeWorkOrders.includes(awo.id) && activePriorities.includes(awo.id)
                                        ?
                                        <Link className={'btn btn-success'}
                                              to={`/priority_reports/${awo.id}/`}>Detail Priority</Link>
                                        :
                                        <Link className={'btn btn-danger'}
                                              to={`/clients/${awo.id}/addpriority/`}>Set Priority</Link>
                                    :
                                    ("Create Work Order For Job")
                            }

                        </Col>

                        <Col className={"Col AddHourCol"}>
                            {
                                activeWorkOrders.includes(awo.id)
                                    ?
                                    ('So True')
                                    &&
                                    activeWorkOrders.includes(awo.id) && activeTechComments.includes(awo.id)
                                        ?
                                        <Link className={'btn btn-success'}
                                              to={`/comment/${awo.id}/`}>Review Comment</Link>
                                        :
                                        <Link className={'btn btn-danger'}
                                              to={`/clients/${awo.id}/add_comment/`}>Add Comment</Link>
                                    :
                                    ("Create Work Order For Job")
                            }

                        </Col>

                    </Row>

                </Row>
            </div>
        )
        setData(postData)
        setPageCount(Math.ceil(data.length / perPage))
    }
    const handlePageClick = (e) => {
        const selectedPage = e.selected;
        // setOffset(selectedPage + 1)
        setOffset(selectedPage * perPage)
    };


    useEffect(() => {
        fetchData();
    }, [offset]);

    // console.log('render');
    // if (resp.data) {
    //     console.log("d", resp.data, resp.pres, resp.ons, resp.prop, resp.inv, resp.workO, resp.cl, resp.hrs, resp.pri, resp.com);
    // }


    return (
        <div className={"banner_heading"}>

          <h1>Finished Work Orders</h1>

            <div>
                {data}
                <ReactPaginate
                    previousLabel={"prev"}
                    nextLabel={"next"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"}
                />
            </div>

        </div>
    )
}

export default FinishedWorkOrders


// import React, {Component, useContext} from "react";
// import {Card, Col, Container, Nav, Row} from "react-bootstrap";
// import axios from "axios";
// import {Link} from "react-router-dom";
// import CreateClient from "./CreateClient";
// import {ClockLoader} from "react-spinners";
// import ReactPaginate from 'react-paginate';
// import {useSelector} from "react-redux";
//
//
//
//
// //TODO: the refresh needs a timer on it. Otherwise it just runs all the time
// export class FinishedWorkOrders extends Component {
//
//     constructor(props) {
//         super(props);
//         this.state = {
//             // Active Work Orders clients
//             AWOS: [],
//             clientIsLoading1: true,
//             clientIsLoading2: true,
//
//             //Active PreSites
//             APS: [],
//             preSiteIsLoading: true,
//
//             // Active On Sites
//             AOS: [],
//             onSiteIsLoading: true,
//
//             // Active Proposals
//             AP: [],
//             proposalIsLoading: true,
//
//             // Active Invoices
//             AI: [],
//             invoiceIsLoading: true,
//
//             // Active WorkOrders
//             ACWO: [],
//             workOrderIsLoading: true,
//
//             // Active CheckLists
//             ACL: [],
//             checkListIsLoading: true,
//
//             // WorkHours
//             WO: [],
//             workHourIsLoading: true,
//
//             // Priorities
//             priority: [],
//             priorityIsLoading: true,
//
//             // Comments
//             comments: [],
//             commentsAreLoading: true,
//
//             offset: 0,
//             data: [],
//             perPage: 10,
//             currentPage: 0
//         }
//         this.handlePageClick = this
//             .handlePageClick
//             .bind(this);
//
//     }
//
//     receivedData() {
//         axios.get('https://homesafetysolutions.pythonanywhere.com/api/finished_work_orders/', {
//             // withCredentials: true,
//             headers: {
//                 "Accept": 'application/json',
//                 "Content-Type": 'application/json'
//             },
//         })
//             .then(response => {
//                 this.setState({AWOS: response.data});
//                 this.setState({clientIsLoading: false});
//             })
//
//         axios.get('https://homesafetysolutions.pythonanywhere.com/api/presites/', {
//             headers: {
//                 "Accept": 'application/json',
//                 "Content-Type": 'application/json'
//             },
//         })
//             .then(response => {
//                 this.setState({APS: response.data});
//                 this.setState({preSiteIsLoading: false});
//             })
//
//         axios.get('https://homesafetysolutions.pythonanywhere.com/api/onsites/', {
//             headers: {
//                 "Accept": 'application/json',
//                 "Content-Type": 'application/json'
//             },
//         })
//             .then(response => {
//                 this.setState({AOS: response.data});
//                 this.setState({onSiteIsLoading: false});
//             })
//
//         axios.get('https://homesafetysolutions.pythonanywhere.com/api/proposals/', {
//             headers: {
//                 "Accept": 'application/json',
//                 "Content-Type": 'application/json'
//             },
//         })
//             .then(response => {
//                 this.setState({AP: response.data});
//                 this.setState({proposalIsLoading: false});
//             })
//
//         axios.get('https://homesafetysolutions.pythonanywhere.com/api/invoices/', {
//             headers: {
//                 "Accept": 'application/json',
//                 "Content-Type": 'application/json'
//             },
//         })
//             .then(response => {
//                 this.setState({AI: response.data});
//                 this.setState({invoiceIsLoading: false});
//             })
//
//         axios.get('https://homesafetysolutions.pythonanywhere.com/api/workorders/',
//             {
//                 headers: {
//                     "Accept": 'application/json',
//                     "Content-Type": 'application/json'
//                 },
//             })
//             .then(response => {
//                 this.setState({ACWO: response.data});
//                 this.setState({workOrderIsLoading: false});
//             })
//
//         axios.get('https://homesafetysolutions.pythonanywhere.com/api/checklists/', {
//             headers: {
//                 "Accept": 'application/json',
//                 "Content-Type": 'application/json'
//             },
//         })
//             .then(response => {
//                 this.setState({ACL: response.data});
//                 this.setState({checkListIsLoading: false});
//             })
//
//         axios.get('https://homesafetysolutions.pythonanywhere.com/api/workhours/', {
//             headers: {
//                 "Accept": 'application/json',
//                 "Content-Type": 'application/json'
//             },
//         })
//             .then(response => {
//                 this.setState({WO: response.data});
//                 this.setState({workHourIsLoading: false});
//             })
//
//         axios.get('https://homesafetysolutions.pythonanywhere.com/api/priority_reports/', {
//             headers: {
//                 "Accept": 'application/json',
//                 "Content-Type": 'application/json'
//             },
//         })
//             .then(response => {
//                 this.setState({priority: response.data});
//                 this.setState({priorityIsLoading: false});
//             })
//
//         axios
//             .get('https://homesafetysolutions.pythonanywhere.com/api/comments/', {
//                 headers: {
//                     "Accept": 'application/json',
//                     "Content-Type": 'application/json'
//                 },
//             })
//             .then(response => {
//                 this.setState({comments: response.data});
//                 this.setState({commentsAreLoading: false});
//             })
//
//
//         axios.get(`https://homesafetysolutions.pythonanywhere.com/api/finished_work_orders/`)
//             .then(res => {
//                 this.setState({clientIsLoading2: false});
//                 const {
//                     APS,
//                     AOS,
//                     AP,
//                     AI,
//                     ACWO,
//                     ACL,
//                     WO,
//                     comments,
//                     priority,
//                 } = this.state;
//
//                 let activePreSites = APS.map((client) => client.client)
//                 let activeOnSites = AOS.map((client) => client.client)
//                 let activeProposals = AP.map((client) => client.client)
//                 let activeInvoices = AI.map((client) => client.client)
//                 let activeWorkOrders = ACWO.map((client) => client.client)
//                 let activeCheckLists = ACL.map((client) => client.client)
//                 let activeWorkHours = WO.map((client) => client.client)
//                 let priorities = priority.map((client) => client.client)
//                 let techcomments = comments.map((client) => client.client)
//
//                 const data = res.data;
//                 const slice = data.slice(this.state.offset, this.state.offset + this.state.perPage)
//                 const postData = slice.map(pd =>
//                     <React.Fragment
//                         key={pd.work_site_address}
//                     >
//                         <Row
//                             className={"workOrderRow"}
//                         >
//                             <Col>
//                                 <Link className={'btn btn-primary'}
//                                       to={`/client_details/${pd.id}/`}>
//                                     {pd.work_site_address}
//                                 </Link>
//                             </Col>
//
//                             <Col>
//
//                                 {
//                                     activePreSites.includes(pd.id)
//                                         ?
//                                         (<Link className={'btn btn-info'}
//                                                to={`/presite/${pd.id}/`}>
//                                             Detail Pre-Site
//                                         </Link>)
//                                         :
//                                         (<Link className={'btn btn-warning'}
//                                                to={`/clients/${pd.id}/addpresite`}>
//                                             Add Pre-Site
//                                         </Link>)
//                                 }
//                             </Col>
//
//                             <Col>
//                                 {
//                                     activePreSites.includes(pd.id)
//                                         ?
//                                         ('So True')
//                                         &&
//                                         activeOnSites.includes(pd.id)
//                                             ?
//                                             (<Link className={'btn btn-info'}
//                                                    to={`/onsite/${pd.id}/`}>Detail
//                                                 OnSite</Link>)
//                                             :
//                                             (<Link className={'btn btn-warning'}
//                                                    to={`/clients/${pd.id}/addonsite/`}>Add
//                                                 OnSite</Link>)
//                                         :
//                                         ("Fill out Pre-Site")
//                                 }
//
//                             </Col>
//
//                             <Col>
//
//                                 {
//                                     activeOnSites.includes(pd.id)
//                                         ?
//                                         ('So True')
//                                         &&
//                                         activeProposals.includes(pd.id)
//                                             ?
//                                             (<Link className={'btn btn-info'}
//                                                    to={`/proposals/${pd.id}/`}>
//                                                 Detail Proposal
//                                             </Link>)
//                                             :
//                                             (<Link className={'btn btn-warning'}
//                                                    to={`/clients/${pd.id}/addproposal/`}> Add
//                                                 Proposal </Link>)
//                                         :
//                                         ("Fill out On-Site")
//                                 }
//                             </Col>
//
//                             <Col>
//                                 {
//                                     activeProposals.includes(pd.id)
//                                         ?
//                                         ('So True')
//                                         &&
//                                         activeInvoices.includes(pd.id)
//                                             ?
//                                             (<Link className={'btn btn-info'}
//                                                    to={`/invoices/${pd.id}/`}> Detail
//                                                 Invoice </Link>)
//                                             :
//                                             (<Link className={'btn btn-warning'}
//                                                    to={`/clients/${pd.id}/addinvoice/`}>Add
//                                                 Invoice </Link>)
//                                         :
//                                         ("Fill out Proposal")
//                                 }
//                             </Col>
//
//                             <Col>
//                                 {
//                                     activeInvoices.includes(pd.id)
//                                         ?
//                                         ('So True')
//                                         &&
//                                         activeWorkOrders.includes(pd.id)
//                                             ?
//                                             (<Link className={'btn btn-info'}
//                                                    to={`/workorders/${pd.id}/`}> Detail
//                                                 Work-Order </Link>)
//                                             :
//                                             (<Link className={'btn btn-warning'}
//                                                    to={`/clients/${pd.id}/addworkorder/`}>Add
//                                                 Work-Order</Link>)
//                                         :
//                                         ("Fill out Invoice")
//                                 }
//
//                             </Col>
//
//                             <Col>
//                                 {
//                                     activeWorkOrders.includes(pd.id)
//                                         ?
//                                         ('So True')
//                                         &&
//                                         activeCheckLists.includes(pd.id)
//                                             ?
//                                             (<Link className={'btn btn-info'}
//                                                    to={`/checklist/${pd.id}/`}>
//                                                 Detail Check List
//                                             </Link>)
//                                             :
//                                             (<Link className={'btn btn-warning'}
//                                                    to={`/clients/${pd.id}/addchecklist/`}>Add
//                                                 Check List </Link>)
//                                         :
//                                         ("Fill out Work Order")
//                                 }
//                             </Col>
//                             <div className={'Row AddHourRow'}>
//
//                                     <span className={"Col AddHourCol"}>
//                                         {
//                                             activeWorkOrders.includes(pd.id)
//                                                 ?
//                                                 ('So True')
//                                                 &&
//                                                 activeWorkOrders.includes(pd.id)
//                                                     ?
//                                                     <Link className={'btn btn-warning'}
//                                                           to={`/clients/${pd.id}/addhours/`}>Add Hours</Link>
//                                                     :
//                                                     ("Create Work Order For Job")
//                                                 :
//                                                 ("Create Work Order For Job")
//                                         }
//
//                                     </span>
//                                 <span className={"Col AddHourCol"}>
//                                         {
//                                             activeWorkOrders.includes(pd.id)
//                                                 ?
//                                                 ('So True')
//                                                 &&
//                                                 activeWorkHours.includes(pd.id)
//                                                     ?
//                                                     (<Link className={'btn btn-info'} to={`/clienthours/${pd.id}/`}>
//                                                         Hours Worked
//                                                     </Link>)
//
//                                                     :
//                                                     ("Create Hours For Job")
//                                                 :
//                                                 ("Create Hours For Job")
//                                         }
//                                     </span>
//
//                                 <span className={"Col AddHourCol"}>
//                                         {
//                                             activeWorkOrders.includes(pd.id)
//                                                 ?
//                                                 ('So True')
//                                                 &&
//                                                 activeWorkOrders.includes(pd.id) && priorities.includes(pd.id)
//                                                     ?
//                                                     <Link className={'btn btn-success'}
//                                                           to={`/priority_reports/${pd.id}/`}>Detail Priority</Link>
//                                                     :
//                                                     <Link className={'btn btn-danger'}
//                                                           to={`/clients/${pd.id}/addpriority/`}>Set Priority</Link>
//                                                 :
//                                                 ("Create Work Order For Job")
//                                         }
//
//                                     </span>
//
//                                 <span className={"Col AddHourCol"}>
//                                         {
//                                             activeWorkOrders.includes(pd.id)
//                                                 ?
//                                                 ('So True')
//                                                 &&
//                                                 activeWorkOrders.includes(pd.id) && techcomments.includes(pd.id)
//                                                     ?
//                                                     <Link className={'btn btn-success'}
//                                                           to={`/comment/${pd.id}/`}>Review Comment</Link>
//                                                     :
//                                                     <Link className={'btn btn-danger'}
//                                                           to={`/clients/${pd.id}/add_comment/`}>Add Comment</Link>
//                                                 :
//                                                 ("Create Work Order For Job")
//                                         }
//
//                                     </span>
//
//                             </div>
//
//                         </Row>
//                     </React.Fragment>)
//
//                 this.setState({
//                     pageCount: Math.ceil(data.length / this.state.perPage),
//
//                     postData
//                 })
//             });
//     }
//     handlePageClick = (e) => {
//         const selectedPage = e.selected;
//         const offset = selectedPage * this.state.perPage;
//
//         this.setState({
//             currentPage: selectedPage,
//             offset: offset
//         }, () => {
//             this.receivedData()
//         });
//
//     };
//
//     componentDidMount() {
//         this.receivedData()
//     }
//
//     render() {
//
//         const {
//             clientIsLoading,
//             clientIsLoading2,
//             preSiteIsLoading,
//             onSiteIsLoading,
//             proposalIsLoading,
//             invoiceIsLoading,
//             workOrderIsLoading,
//             checkListIsLoading,
//             workHourIsLoading,
//             priorityIsLoading,
//             commentsAreLoading,
//         } = this.state;
//
//
//         if (clientIsLoading || clientIsLoading2 || preSiteIsLoading || onSiteIsLoading || proposalIsLoading || invoiceIsLoading ||
//             workOrderIsLoading || checkListIsLoading || workHourIsLoading || priorityIsLoading || commentsAreLoading) {
//             return <div className={'loadingSpinner'}>Loading...<br/> <ClockLoader color={'#0d00ff'}/></div>
//         }
//
//
//         return (
//
//             <Container fluid>
//                 <br/>
//                 <h1>Finished Work Orders</h1>
//                 <br />
//
//                 <div>
//                     {this.state.postData}
//                     <ReactPaginate
//                         previousLabel={"prev"}
//                         nextLabel={"next"}
//                         breakLabel={"..."}
//                         breakClassName={"break-me"}
//                         pageCount={this.state.pageCount}
//                         marginPagesDisplayed={2}
//                         pageRangeDisplayed={5}
//                         onPageChange={this.handlePageClick}
//                         containerClassName={"pagination"}
//                         subContainerClassName={"pages pagination"}
//                         activeClassName={"active"}/>
//                 </div>
//             </Container>
//         );
//     }
// }
//
// export default FinishedWorkOrders;


// import React, {Component} from "react";
// import {Col, Container, Row} from "react-bootstrap";
// import axios from "axios";
// import {Link} from "react-router-dom";
// import {ClockLoader} from "react-spinners";
//
//
//
// //TODO: the refresh needs a timer on it. Otherwise it just runs all the time
//
// export class FinishedWorkOrders extends Component{
//
//     constructor(props) {
//         super(props);
//
//         this.state = {
//             // Active Work Orders clients
//             AWOS: [],
//             clientIsLoading: true,
//
//             //Active PreSites
//             APS: [],
//             preSiteIsLoading: true,
//
//             // Active On Sites
//             AOS: [],
//             onSiteIsLoading: true,
//
//             // Active Proposals
//             AP: [],
//             proposalIsLoading: true,
//
//             // Active Invoices
//             AI: [],
//             invoiceIsLoading: true,
//
//             // Active WorkOrders
//             ACWO: [],
//             workOrderIsLoading: true,
//
//             // Active CheckLists
//             ACL: [],
//             checkListIsLoading: true,
//
//             // WorkHours
//             WO: [],
//             workHourIsLoading: true,
//         }
//     }
//
//
//     componentDidMount() {
//         axios.get('https://homesafetysolutions.pythonanywhere.com/api/finished_work_orders/',{
//             headers:{
//                 "Accept":'application/json',
//                 "Content-Type":'application/json'
//             },
//         })
//             .then(response=>{
//                 this.setState({AWOS: response.data});
//                 this.setState({clientIsLoading: false});
//             })
//
//         axios.get('https://homesafetysolutions.pythonanywhere.com/api/presites/',{
//             headers:{
//                 "Accept":'application/json',
//                 "Content-Type":'application/json'
//             },
//         })
//             .then(response=>{
//                 this.setState({APS: response.data});
//                 this.setState({preSiteIsLoading: false});
//             })
//
//         axios.get('https://homesafetysolutions.pythonanywhere.com/api/onsites/',{
//             headers:{
//                 "Accept":'application/json',
//                 "Content-Type":'application/json'
//             },
//         })
//             .then(response=>{
//                 this.setState({AOS: response.data});
//                 this.setState({onSiteIsLoading: false});
//             })
//
//         axios.get('https://homesafetysolutions.pythonanywhere.com/api/proposals/',{
//             headers:{
//                 "Accept":'application/json',
//                 "Content-Type":'application/json'
//             },
//         })
//             .then(response=>{
//                 this.setState({AP: response.data});
//                 this.setState({proposalIsLoading: false});
//             })
//
//         axios.get('https://homesafetysolutions.pythonanywhere.com/api/invoices/',{
//             headers:{
//                 "Accept":'application/json',
//                 "Content-Type":'application/json'
//             },
//         })
//             .then(response=>{
//                 this.setState({AI: response.data});
//                 this.setState({invoiceIsLoading: false});
//             })
//
//         axios.get('https://homesafetysolutions.pythonanywhere.com/api/workorders/',{
//             headers:{
//                 "Accept":'application/json',
//                 "Content-Type":'application/json'
//             },
//         })
//             .then(response=>{
//                 this.setState({ACWO: response.data});
//                 this.setState({workOrderIsLoading: false});
//             })
//
//         axios.get('https://homesafetysolutions.pythonanywhere.com/api/checklists/',{
//             headers:{
//                 "Accept":'application/json',
//                 "Content-Type":'application/json'
//             },
//         })
//             .then(response=>{
//                 this.setState({ACL: response.data});
//                 this.setState({checkListIsLoading: false});
//             })
//
//         axios.get('https://homesafetysolutions.pythonanywhere.com/api/workhours/',{
//             headers:{
//                 "Accept":'application/json',
//                 "Content-Type":'application/json'
//             },
//         })
//             .then(response=>{
//                 this.setState({WO: response.data});
//                 this.setState({workHourIsLoading: false});
//             })
//
//     }
//
//     render() {
//
//         const {
//             AWOS, APS, AOS, AP, AI, ACWO, ACL, WO, clientIsLoading, preSiteIsLoading, onSiteIsLoading,
//             proposalIsLoading, invoiceIsLoading, workOrderIsLoading, checkListIsLoading, workHourIsLoading
//         } = this.state;
//
//         if (clientIsLoading || preSiteIsLoading || onSiteIsLoading || proposalIsLoading || invoiceIsLoading || workOrderIsLoading || checkListIsLoading || workHourIsLoading){
//             return <div className={'loadingSpinner'} >Loading...<br/> <ClockLoader color="#0d00ff" /></div>
//         }
//
//         let activePreSites = APS.map((client)=> client.client)
//         let activeOnSites = AOS.map((client)=> client.client)
//         let activeProposals = AP.map((client) => client.client)
//         let activeInvoices = AI.map((client) => client.client)
//         let activeWorkOrders = ACWO.map((client) => client.client)
//         let activeCheckLists = ACL.map((client) => client.client)
//         let activeWorkHours = WO.map((client) => client.client)
//
//         return (
//
//             <Container fluid>
//                 <br />
//                 <h1>Finished Work Orders</h1>
//                 <br />
//
//                 {AWOS.map(awo=>
//                     <Row key={awo.work_site_address} className={"workOrderRow"}>
//
//
//                         <Col>
//                             <Link className={'btn btn-primary'} to={`/client_details/${awo.id}/`}>
//                                 {awo.work_site_address}
//                             </Link>
//                         </Col>
//
//                         <Col>
//
//                             {
//                                 activePreSites.includes(awo.id)
//                                     ?
//                                     (<Link className={'btn btn-info'} to={`/presite/${awo.id}/`} >
//                                         Detail Pre-Site
//                                     </Link>)
//                                     :
//                                     (<Link className={'btn btn-warning'} to={`/clients/${awo.id}/addpresite`} >
//                                         Add Pre-Site
//                                     </Link>)
//                             }
//                         </Col>
//
//                         <Col>
//                             {
//                                 activePreSites.includes(awo.id)
//                                     ?
//                                     ('So True')
//                                     &&
//                                     activeOnSites.includes(awo.id)
//                                         ?
//                                         (<Link className={'btn btn-info'} to={`/onsite/${awo.id}/`}>Detail OnSite</Link>)
//                                         :
//                                         (<Link className={'btn btn-warning'} to={`/clients/${awo.id}/addonsite/`} >Add OnSite</Link>)
//                                     :
//                                     ("Fill out Pre-Site")
//                             }
//
//                         </Col>
//
//                         <Col>
//
//                             {
//                                 activeOnSites.includes(awo.id)
//                                     ?
//                                     ('So True')
//                                     &&
//                                     activeProposals.includes(awo.id)
//                                         ?
//                                         (<Link className={'btn btn-info'} to={`/proposals/${awo.id}/`} >
//                                             Detail Proposal
//                                         </Link>)
//                                         :
//                                         (<Link className={'btn btn-warning'} to={`/clients/${awo.id}/addproposal/`} > Add Proposal </Link>)
//                                     :
//                                     ("Fill out On-Site")
//                             }
//                         </Col>
//
//                         <Col>
//                             {
//                                 activeProposals.includes(awo.id)
//                                     ?
//                                     ('So True')
//                                     &&
//                                     activeInvoices.includes(awo.id)
//                                         ?
//                                         (<Link className={'btn btn-info'} to={`/invoices/${awo.id}/`}> Detail Invoice </Link>)
//                                         :
//                                         (<Link className={'btn btn-warning'} to={`/clients/${awo.id}/addinvoice/`}>Add Invoice </Link>)
//                                     :
//                                     ("Fill out Proposal")
//                             }
//                         </Col>
//
//                         <Col>
//                             {
//                                 activeInvoices.includes(awo.id)
//                                     ?
//                                     ('So True')
//                                     &&
//                                     activeWorkOrders.includes(awo.id)
//                                         ?
//                                         (<Link className={'btn btn-info'} to={`/workorders/${awo.id}/`}> Detail Work-Order </Link>)
//                                         :
//                                         (<Link className={'btn btn-warning'} to={`/clients/${awo.id}/addworkorder/`}>Add Work-Order</Link>)
//                                     :
//                                     ("Fill out Invoice")
//                             }
//
//                         </Col>
//
//                         <Col>
//                             {
//                                 activeWorkOrders.includes(awo.id)
//                                     ?
//                                     ('So True')
//                                     &&
//                                     activeCheckLists.includes(awo.id)
//                                         ?
//                                         (<Link className={'btn btn-info'} to={`/checklist/${awo.id}/`} >
//                                             Detail Check List
//                                         </Link>)
//                                         :
//                                         (<Link className={'btn btn-warning'} to={`/clients/${awo.id}/addchecklist/`} >Add Check List </Link>)
//                                     :
//                                     ("Fill out Work Order")
//                             }
//                         </Col>
//
//                         <div className={'Row AddHourRow'}>
//
//                                     <span className={"Col AddHourCol"}>
//                                         <Link className={'btn btn-warning'} to={`/clients/${awo.id}/addhours/`} >Add Hours </Link>
//                                     </span>
//
//                             <span className={"Col AddHourCol"}>
//                                         {
//                                             activeWorkOrders.includes(awo.id)
//                                                 ?
//                                                 ('So True')
//                                                 &&
//                                                 activeWorkHours.includes(awo.id)
//                                                     ?
//                                                     (<Link className={'btn btn-info'} to={`/clienthours/${awo.id}/`} >
//                                                         Hours Worked
//                                                     </Link>)
//
//                                                     :
//                                                     ("Create Hours For Job")
//                                                 :
//                                                 ("Create Hours For Job")
//                                         }
//                                     </span>
//
//                         </div>
//
//                     </Row>
//
//                 )}
//
//             </Container>
//         );
//     }
// }
// export default FinishedWorkOrders;
